import { Grid } from '@backstage/ui';
import { EntityApiDefinitionCard } from '@backstage/plugin-api-docs';
import { EntityAboutCard, EntityLayout } from '@backstage/plugin-catalog';
import { EntityWarningContent } from './common/EntityWarningContent';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityLinksGridItem } from './common/EntityLinksGridItem';
import { ApiProvidersGridItem } from './common/ApiProvidersGridItem';
import { ApiConsumersGridItem } from './common/ApiConsumersGridItem';
import { ApiEntityV1alpha1 } from '@backstage/catalog-model';

export const ApiEntity = () => {
  const { entity } = useEntity();
  const api = entity as ApiEntityV1alpha1;
  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid.Root columns="12" gap="4">
          {EntityWarningContent}
          <Grid.Item colSpan={{ initial: '12', md: '6' }}>
            <EntityAboutCard />
          </Grid.Item>
          <EntityLinksGridItem colSpan={{ initial: '12', md: '6' }} />
          <ApiProvidersGridItem colSpan={{ initial: '12', md: '6' }} />
          <ApiConsumersGridItem colSpan={{ initial: '12', md: '6' }} />
        </Grid.Root>
      </EntityLayout.Route>
      {api.spec.definition ? (
        <EntityLayout.Route path="/definition" title="Definition">
          <Grid.Root columns="12" gap="4">
            <Grid.Item colSpan="12">
              <EntityApiDefinitionCard />
            </Grid.Item>
          </Grid.Root>
        </EntityLayout.Route>
      ) : null}
    </EntityLayout>
  );
};
